define('ItemKeyMapping.ImagesSorting', [
    'Item.KeyMapping',
    'SC.Configuration',
    'Utils',

    'underscore'
],
function ItemKeyMappingImagesSorting(
    ItemKeyMapping,
    Configuration,
    Utils,

    _
) {
    'use strict';

    Configuration.itemKeyMapping = Configuration.itemKeyMapping || {};

    _(Configuration.itemKeyMapping).extend({
        _thumbnail: function _thumbnail(item) {
            var itemImagesDetail = item.get('itemimages_detail') || {};
            var parentItem;
            var images;

            // If you generate a thumbnail position in the itemimages_detail it will be used
            if (itemImagesDetail.thumbnail) {
                if (_.isArray(itemImagesDetail.thumbnail.urls) && itemImagesDetail.thumbnail.urls.length) {
                    return itemImagesDetail.thumbnail.urls[0];
                }

                return itemImagesDetail.thumbnail;
            }

            // otherwise it will try to use the storedisplaythumbnail
            if (SC.ENVIRONMENT.siteType && SC.ENVIRONMENT.siteType === 'STANDARD' && item.get('storedisplaythumbnail')) {
                return {
                    url: item.get('storedisplaythumbnail'),
                    altimagetext: item.get('_name')
                };
            }
            // No images huh? carry on

            parentItem = item.get('_matrixParent');
            // If the item is a matrix child, it will return the thumbnail of the parent
            if (parentItem && parentItem.get('internalid')) {
                return parentItem.get('_thumbnail');
            }

            // this is the only modified line
            // before: images = Utils.imageFlatten(itemImagesDetail);
            // after: images = item.getImages();
            images = item.getImages();
            // If you using the advance images features it will grab the 1st one
            if (images.length) {
                return images[0];
            }

            // still nothing? image the not available
            return {
                url: Utils.getThemeAbsoluteUrlOfNonManagedResources('img/no_image_available.jpeg', Configuration.get('imageNotAvailable')),
                altimagetext: item.get('_name')
            };
        }
    });
});

